module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Medium.4918c71e.ttf";